import {
  AccordionDetails as MuiAccordionDetails,
  AccordionDetailsProps as MuiAccordionDetailsProps,
} from "@mui/material";

export const AccordionContent = (props: MuiAccordionDetailsProps) => {
  return <MuiAccordionDetails {...props} />;
};
